import { render, staticRenderFns } from "./OrderReportListCard.vue?vue&type=template&id=725ad00a"
import script from "./OrderReportListCard.vue?vue&type=script&lang=ts"
export * from "./OrderReportListCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports